import { PreAdmissionTab } from '@/api/enum/common.enum';
import { showLabel } from '@/utils/helper';
import { Box, Chip } from '@mui/material';

interface Props {
	status: number | string | undefined;
	label: string;
}

export default function PreAdmissionChip({ status, label }: Props) {
	return (
		<Chip
			color={
				status == PreAdmissionTab.progress
					? 'chipPrimary'
					: status == PreAdmissionTab.submitted
					? 'chipTertiary'
					: 'default'
			}
			sx={{
				height: 'auto',
				minHeight: '24px',
				maxWidth: '100%',
				overflow: 'hidden',
				whiteSpace: 'normal',
				wordBreak: 'break-word',
				padding: '4px 4px',
			}}
			label={
				<Box
					sx={{
						width: '100%',
						whiteSpace: 'normal',
						wordBreak: 'break-word',
					}}
				>
					{label}
				</Box>
			}
		/>
	);
}
